// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"vU","selections":"wU","pillsDesktopSearchMenu":"xU"};